import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'pcm-addon-field',
	templateUrl: './addon-field.component.html',
	styleUrls: ['./addon-field.component.scss']
})
export class AddonFieldComponent implements OnInit {

	@Input() field;
	@Input() index;

	@Output() deleteField: EventEmitter<any> = new EventEmitter();

	constructor() { }

	ngOnInit() {

	}

	deleteThis() {
		this.deleteField.emit({
			event: event,
			field: this.field,
			index: this.index
		});
	}



}
